import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  show: boolean;
}

const DuplicateEstimationModal = (props: IProps) => {
  const { show, ...rest } = props;

  return (
    <ModalContainer
      {...rest}
      title="Duplicate Solar Estimation"
      show={show}
      size="modal-md"
    >
      <Row>
        <Col className="text-color-2 font-weight-400 font-size-14">
          Are you sure you want to duplicate this estimation?
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default DuplicateEstimationModal;
